import React from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  TextField,
  Tabs,
  Tab,
  Chip,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { motion } from "framer-motion";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

const OrdersMobileHeader = ({ 
  search, 
  onSearchChange, 
  onCreateOrder,
  showShiprocketStatus,
  onShiprocketStatusChange,
  shiprocketStatusDisabled,
  selectedStatus,
  onStatusChange,
  statusCounts,
  statusOptions,
  formatStatus
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <Card
        sx={{
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(20px)",
          borderRadius: "24px",
          mb: 3,
          border: "1px solid rgba(255, 255, 255, 0.4)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.03)",
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* Title Row */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 900,
                  color: "text.primary",
                  fontSize: "1.6rem",
                  letterSpacing: '-0.02em'
                }}
              >
                Orders
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  variant="caption"
                  sx={{ color: "text.secondary", fontWeight: 800, fontSize: "0.65rem", letterSpacing: '0.1em' }}
                >
                  SHIPROCKET
                </Typography>
                <Switch
                  checked={!!showShiprocketStatus}
                  onChange={onShiprocketStatusChange}
                  disabled={!!shiprocketStatusDisabled}
                  size="small"
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "primary.main",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "primary.main",
                    },
                  }}
                />
              </Box>
            </Box>

            {/* Search and Create Button Row */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                variant="outlined"
                size="small"
                value={search}
                onChange={onSearchChange}
                placeholder="Search by ID or Name..."
                InputProps={{
                  startAdornment: (
                    <SearchIcon
                      sx={{ color: "text.secondary", mr: 1, fontSize: 18 }}
                    />
                  ),
                }}
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: '16px',
                    fontSize: "0.9rem",
                    background: "rgba(0,0,0,0.02)",
                    transition: 'all 0.2s',
                    "& fieldset": { borderColor: 'transparent' },
                    "&:hover": { background: "rgba(0,0,0,0.04)" },
                    "&.Mui-focused": {
                      background: "#fff",
                      "& fieldset": { borderColor: 'primary.main', borderWidth: '1px' },
                    },
                  },
                }}
              />

              <Button
                onClick={onCreateOrder}
                variant="contained"
                sx={{
                  background: '#B51D6E',
                  color: "#FFFFFF !important",
                  fontWeight: 900,
                  textTransform: "none",
                  borderRadius: '16px',
                  minWidth: "50px",
                  height: "45px",
                  boxShadow: '0 8px 16px rgba(181, 29, 110, 0.2)',
                  "&:hover": {
                    background: '#B51D6E',
                    boxShadow: '0 12px 20px rgba(181, 29, 110, 0.25)',
                    transform: 'translateY(-1px)',
                  }
                }}
              >
                <AddIcon sx={{ fontSize: 24 }} />
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default OrdersMobileHeader;
